module.exports = __webpack_public_path__ + "static/mustache-736a5765e95a417db7ffc6afe4829298.webm";